// extracted by mini-css-extract-plugin
export default {"container":"dashboardList_container__uDstj"};